import React from "react";
import { Row, } from "reactstrap";
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

const Negotiations = (props) => {

    const name = props.name;
    const pro = props.pro;
    const message = props.message
    const extra = props.extra
    const type = props.type
    return (
        <>
            <Row className='chat-item' style={{ width: '100%', backgroundColor: '', display: 'flex', paddingLeft: '0px', alignItems: '', margin: '0px',height: '70px',padding: '10px' }}>
                <div>
                    <img style={{ width: '50px', height: '50px', borderRadius: '25px' }} alt='Profile_Pic' src={pro} onError={(e) => { e.target.src = 'https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1621775490903-place.png' }} />
                </div>
                <div style={{flex: 1,display: 'flex',flexDirection: 'column',paddingLeft: '15px',overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}}>
                    <h3 className=" text-dark" style={{marginBottom: 0,width: 'auto',fontWeight: 'normal'}}><Link className='underline-hover' to={'/main/profile/'+name}>{name}</Link></h3>
                    <p className="text-dark" style={{marginBottom: 0,fontWeight: (type?'bold': ''),width: '90%'}}>{message}</p>
                </div>
                <div>
                    <p className="text-lightc mb-1" style={{ fontSize: '12px', color: '#8290B0'}}>{extra}</p>
                    {(type === true ? <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }} ><div style={{width: '20px',height: '20px',borderRadius: '20px',backgroundColor: 'red'}}></div></div>:null)}
                </div>
            </Row>
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        // adminValue: state.switchRoutes.admin,
        // userValue: state.switchRoutes.user,
        // fullname: state.tempUser,
        username: state.userName,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Negotiations);
// export default Negotiations
